import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerArchivosInformados = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerArchivosInformados",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerArchivosInformados };
